import fromAnyToUpperCase from 'utils/converters/any/fromAnyToUpperCase.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

export const matchesServiceAndNotDeleted = (options) => {
  const serviceName = fromAnyToString(options?.serviceName);
  if (!serviceName) return false;

  const item = options?.item;
  const itemName = fromAnyToString(item?.name);
  if (!itemName) return false;

  if (item?.deleted) return false;

  if (options?.isCaseSensitive) {
    return fromAnyToUpperCase(itemName) === fromAnyToUpperCase(serviceName);
  }

  return itemName === serviceName;
};
